module.exports = __webpack_public_path__ + "static/media/house.2d7449d8.svg";